import { useState, useEffect } from "react";
import {
    Box,
    Typography,
    CircularProgress
} from "@mui/material";

import { useEgresoSumaRME } from "../../../Services/EgresosRME";
import { useGetSucursal } from "../../../Services/Sucursales";
import { DataGrid } from "@mui/x-data-grid";
import Logocolor from "../../../Image/Logo.png";

export const ReporteFinanciero = () => {
    const { sucursales } = useGetSucursal();

    const {
        getSumaPorMesAnio,
    } = useEgresoSumaRME();

    const [mesAnterior, setMesAnterior] = useState(null);
    const [loading, setLoading] = useState(true);


    useEffect(() => {
        const fetchSumaMesAnterior = async () => {
            try {
                const data = await getSumaPorMesAnio();
                setMesAnterior(data);
            } catch (error) {
                console.error("❌ Error al cargar suma mes anterior:", error);
            } finally {
                setLoading(false);
            }
        };

       
        fetchSumaMesAnterior();

    }, []);

    const obtenerNombreSucursal = (id) => {
    const suc = sucursales?.find(s => s.id === Number(id));
    return suc ? suc.name : "Sucursal desconocida";
};

   const nombreMes = (numero) => {
    const meses = [
        "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
        "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
    ];
    return meses[numero - 1] || "";
};

const mesesOrdenados = [...(mesAnterior?.meses_anteriores || [])].sort((a, b) => {
  if (a.año !== b.año) {
    return b.año - a.año; 
  }
  return b.mes - a.mes; 
});


const columnasBase = [
  { field: "fecha", headerName: "Fecha", flex: 1 },
  { 
    field: "totalMes", 
    headerName: "Monto Total del Mes", 
    flex: 1,
    renderCell: (params) =>
      new Intl.NumberFormat("es-CL", { style: "currency", currency: "CLP", minimumFractionDigits: 0 })
        .format(params.value)
  }
];

// 📌 Obtener todos los branch_id únicos de todos los meses
const branchIdsUnicos = [
    ...new Set(
        mesAnterior?.meses_anteriores?.flatMap(m => m.sucursales.map(s => s.branch_id ?? "sin_asignar")) || []
    )
];

// 📌 Columnas dinámicas de sucursales
const columnasSucursales = branchIdsUnicos.map(branch_id => {
  const nombre = branch_id === "sin_asignar" ? "Sin Asignar" : obtenerNombreSucursal(branch_id);
  return {
    field: `sucursal_${branch_id}`,
    headerName: nombre,
    flex: 1,
    renderCell: (params) =>
      new Intl.NumberFormat("es-CL", { style: "currency", currency: "CLP", minimumFractionDigits: 0 })
        .format(params.value || 0)
  };
});

// 📌 Todas las columnas
const columns = [...columnasBase, ...columnasSucursales];

// 📌 Filas por mes
const rows = mesesOrdenados.map((m, index) => {
  const row = {
    id: index + 1,
    fecha: `${nombreMes(m.mes)} ${m.año}`,
    totalMes: Number(m.totalMes) || 0
  };

  // Inicializar todas las columnas de sucursales en 0
  branchIdsUnicos.forEach(branch_id => row[`sucursal_${branch_id}`] = 0);

  // Asignar valores de sucursales de este mes
  m.sucursales.forEach(s => {
    const key = `sucursal_${s.branch_id ?? "sin_asignar"}`;
    row[key] = Number(s.total) || 0;
  });

  return row;
}) || [];


 
    
    return (
    <>
        {loading ? (
              <Box
        sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "300px",
            gap: 2,
            position: "relative"
        }}
    >
        {/* Círculo */}
        <CircularProgress size={90} thickness={4} sx={{color:'#6fd385ff'}} />

        {/* Imagen centrada encima del círculo */}
        <Box
            component="img"
            src={Logocolor}
            alt="Logo"
            sx={{
                width: "55px",
                height: "55px",
                position: "absolute",
                top:"90px"
            }}
        />

        <Typography sx={{ fontFamily: "Poppins", fontSize: "18px", mt: 2 }}>
            Cargando...
        </Typography>
    </Box>
        ) : (
            <>
                {/* TABLA DE INFORMACIÓN */}
                <Box sx={{ height: 400, mt: 4 }}>
                    <DataGrid 
                        rows={rows}
                        columns={columns}
                        pageSize={10}
                        rowsPerPageOptions={[10, 20, 50]}
                        sx={{
                            fontFamily: 'Poppins, sans-serif',
                            '& .MuiDataGrid-columnHeaders': {
                                color: '#113e21ff',
                                fontWeight: 600,
                                textTransform: 'capitalize',
                            },
                            '& .MuiDataGrid-cell': {
                                textTransform: 'capitalize',
                            },
                        }}
                    />
                </Box>
            </>
        )}
    </>
);

};
